// default options
export const gpsDefaultOptions = {
  enableHighAccuracy: true,
  maximumAge: 30000,
  timeout: 60000
}

// options by gps setting
export const gpsOptions = gps => {
  let opts = Object.assign({}, gpsDefaultOptions)
  if (gps !== 2) opts.enableHighAccuracy = false // allow low accuracy, all 1 pos / 30s
  if (gps === 2) opts.maximumAge = 1000
  if (gps === 1) opts.maximumAge = 30000
  if (gps === 0) opts.maximumAge = 60000
  return opts
}

// stop geolocation service
export const gpsClearWatch = () => {
  navigator.geolocation.clearWatch(window.gps)
}

// start geolocation service
export const gpsWatchPosition = (success, error, options = gpsDefaultOptions) => {
  // if geolocation watcher exist, stop it
  if (window.gps) gpsClearWatch()
  // format gps response
  const successCallback = pos => {
    const userPos = {
      accuracy: pos.coords.accuracy,
      altitude: pos.coords.altitude,
      altitudeAccuracy: pos.coords.altitudeAccuracy,
      heading: pos.coords.heading,
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
      speed: pos.coords.speed,
      timestamp: pos.timestamp
    }
    success(userPos)
  }
  // if error from user, stop watcher
  const errorCallback = err => {
    if (err.code === 1 && window.watch) gpsClearWatch()
    if (err.code === 3) gpsWatchPosition(success, error, options)
    error(err)
  }
  window.gps = navigator.geolocation.watchPosition(successCallback, errorCallback, options)
}
